import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface GroupeAmorces {
  id: number;
  nom: string;
  amorce_ids: number[];
  amorces_noms: string;
  amorces_codes: string;
}

export interface GroupeAmorcesPayload {
  nom: string;
  amorce_ids: number[];
}

@Injectable({ providedIn: 'root' })
export class GroupesAmorcesService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/groupes-amorces`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<GroupeAmorces[]> {
    return this.http
      .get<{ items?: GroupeAmorces[] } | GroupeAmorces[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  create(payload: GroupeAmorcesPayload): Observable<GroupeAmorces> {
    return this.http
      .post<GroupeAmorces>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: GroupeAmorcesPayload): Observable<GroupeAmorces> {
    return this.http
      .put<GroupeAmorces>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
